import { useState } from 'react'

import { Spinner } from './ui/spinner'

interface Props {
  iframeUrl: string
}

export const TranzilaIframe = ({ iframeUrl }: Props) => {
  const [isLoading, setIsLoading] = useState(true)

  return (
    <div className='relative flex h-full w-full items-center justify-center'>
      {isLoading && (
        <div className='absolute inset-0 flex items-center justify-center'>
          <div className='flex flex-col items-center gap-2'>
            <Spinner className='size-8' />
            <p className='text-text-primary text-sm'>טוען דף תשלום...</p>
          </div>
        </div>
      )}
      <iframe
        src={iframeUrl}
        className='h-full w-full border-0'
        allow='payment'
        onLoad={() => setIsLoading(false)}
        title='Tranzila Payment'
      />
    </div>
  )
}
